// extracted by mini-css-extract-plugin
export var measureBox = "_4r-0";